<div class="searchConsole" id="searchConsoleDefult6" aria-hidden="true"
  aria-labelledby="searchConsoleDefultLabel6" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen">
    <div class="modal-content rounded-0 border-0 list-bg-wrapper">
      <button type="button" class="btn-close d-none" aria-label="Close" id="btnClose"
        #btnClose></button>
      <app-advance-header [breadcrumb]="breadCrumb" (valueChange)='getChildValue($event)'></app-advance-header>
      <div class="modal-body list-item-wrapper" style="position: relative; display: block;height: 100vh;">
        <div class="container pb-5 mb-5">
          <div class="row g-4">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="item-search-count">
                {{breadCrumb?.l3_actual_name}} <ng-container
                  *ngIf="productlistdataLength > 0 && productlistdataLength ">{{productlistdataLength}}
                  Result</ng-container>
                <!-- not data found -->
                <div *ngIf="productlistdataLength == 0" class="d-flex justify-content-center mt-2">
                  <ng-container> For filter </ng-container>
                  <ng-container *ngFor="let element of TotalCount_List; let last = last; let i = index;">
                    <ng-container *ngIf="i === TotalCount_List?.length - 1"> and </ng-container>
                    {{element}}<ng-container *ngIf="!last">,</ng-container>
                  </ng-container>
                  <ng-container> no records are available.</ng-container>
                </div>
                <div *ngIf="productlistdataLength == 0" class="d-flex justify-content-center">
                  <img src="../../../assets/advancesearch/Icon-1_Mini truck 1.png" alt="">
                </div>

              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4 item-list" *ngFor="let data of productlistdata">
              <div class="card">
                <div class="card-body">
                  <div class="image-wrapper text-center">
                    <img alt="item-name" src="{{data?.images[0]?.image_url}}" class="img-fluid" />
                    <div class="ellipse1"></div>
                  </div>
                  <h1 class="item-title">
                    {{data?.model}}
                  </h1>
                  <div class="row mt-2 col-12" style="display: flex;justify-content: space-between;">
                    <div class="col-6 pe-2">
                      <button type="button" class="btn btn-primary btn-grad-primary w-100"
                        (click)="viewDetail(data)">View Details</button>
                    </div>
                    <div class="col-6 ps-2">
                      <button type="button" class="btn btn-outline-primary w-100" (click)="bookNow(data)">Book Now</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="filter-list">
              <div *ngIf="smartFilter?.length>0 && smartFilter[0]?.data && smartFilter[0]?.data?.length>0 ">
                <span class="filter-item active" (click)="toggleDetails(smartFilter[0]?.label,'Cabin Type')"
                  [ngClass]="isDetailsVisible == smartFilter[0]?.label ? 'd-none' : ' '">
                  <img alt="" [src]='environment1 + "assets/images/advancesearch/list-item-icon1.png"' loading="lazy" />
                  <span *ngIf="smartFilter?.length > 0">{{smartFilter[0] | changelebels}}</span>

                </span>
                <div class="filter-item-details" [ngClass]="isDetailsVisible == smartFilter[0]?.label ? ' ' : 'd-none'">
                  <div class="filter-item-details-title">
                    <img alt=""
                      [src]="CabinTypeFIlter ?'../../assets/advancesearch/list-item-icon5.png':'../../assets/advancesearch/list-item-icon1.png'" />
                    <span *ngIf="smartFilter?.length > 0"> {{smartFilter[0] | changelebels}}</span>

                    <span class="ms-auto">1/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[0]?.data | keyvalue"
                      (click)="filterClicklistingpage(smartFilter[0]?.label,item.value[smartFilter[0]?.label],1)"
                      [ngClass]=" json[smartFilter[0]?.label] === item.value[smartFilter[0]?.label]  ?'active' : ''">
                      {{item.value[smartFilter[0]?.label]}}
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="smartFilter?.length>1 && smartFilter[1]?.data && smartFilter[1]?.data?.length>0 ">
                <span class="filter-item" (click)="toggleDetails(smartFilter[1]?.label,'Cabin Type')"
                  [ngClass]="isDetailsVisible == smartFilter[1]?.label ? 'd-none' : ' '">
                  <img alt="image1" [src]='environment1 + "assets/images/advancesearch/FIlter_Deck_Length.png"'
                    loading="lazy" />
                  <span *ngIf="smartFilter?.length > 0">{{smartFilter[1] | changelebels}}</span>

                </span>
                <div class="filter-item-details" [ngClass]="isDetailsVisible == smartFilter[1]?.label ? ' ' : 'd-none'">
                  <div class="filter-item-details-title">
                    <img alt=""
                      [src]="FuelTypeFilter  ?'../../assets/advancesearch/list-item-icon5.png':'../../assets/advancesearch/FIlter_Deck_Length.png'" />
                    <span *ngIf="smartFilter?.length > 0"> {{smartFilter[1] | changelebels}}</span>

                    <span class="ms-auto">2/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[1]?.data | keyvalue"
                      (click)="filterClicklistingpage(smartFilter[1]?.label,item.value[smartFilter[1]?.label],2)"
                      [ngClass]="{'active': json[smartFilter[1]?.label] === item.value[smartFilter[1]?.label] }">
                      {{item.value[smartFilter[1]?.label]}}
                    </span>
                  </div>
                </div>
              </div>

              <div *ngIf="smartFilter?.length>2 && smartFilter[2]?.data && smartFilter[2]?.data?.length>0 ">
                <span class="filter-item" (click)="toggleDetails(smartFilter[2]?.label,'Cabin Type')"
                  [ngClass]="isDetailsVisible == smartFilter[2]?.label ? 'd-none' : ' '">
                  <img alt="image2" [src]='environment1 + "assets/images/advancesearch/FIlter_cxlx.png"' />
                  <span *ngIf="smartFilter?.length > 0">{{smartFilter[2] | changelebels}}</span>

                </span>
                <div class="filter-item-details" [ngClass]="isDetailsVisible == smartFilter[2]?.label ? ' ' : 'd-none'">
                  <div class="filter-item-details-title">
                    <img alt=""
                      [src]="DeckLengthFilter  ?'../../assets/advancesearch/list-item-icon5.png':'../../assets/advancesearch/FIlter_cxlx.png'" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[2] | changelebels}}</span>

                    <span class="ms-auto">3/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[2]?.data | keyvalue"
                      (click)="filterClicklistingpage(smartFilter[2]?.label,item.value[smartFilter[2]?.label],3)"
                      [ngClass]="{'active': json[smartFilter[2]?.label] === item.value[smartFilter[2]?.label]}">
                      {{item.value[smartFilter[2]?.label]}}
                    </span>
                  </div>
                </div>

              </div>
              <div *ngIf="smartFilter?.length>3 && smartFilter[3]?.data && smartFilter[3]?.data?.length>0 ">
                <span class="filter-item" (click)="toggleDetails(smartFilter[3]?.label,'Cabin Type')"
                  [ngClass]="isDetailsVisible == smartFilter[3]?.label ? 'd-none' : ' '">
                  <img alt="image3" [src]='environment1 + "assets/images/advancesearch/Filter_TyreType.png"' />
                  <span *ngIf="smartFilter?.length > 0">{{smartFilter[3] | changelebels}}</span>

                </span>
                <div class="filter-item-details" [ngClass]="isDetailsVisible == smartFilter[3]?.label ? ' ' : 'd-none'">
                  <div class="filter-item-details-title">
                    <img alt=""
                      [src]="BodyTypeFilter?'../../assets/advancesearch/list-item-icon5.png':'../../assets/advancesearch/Filter_TyreType.png'" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[3] | changelebels}}</span>

                    <span class="ms-auto">4/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[3]?.data | keyvalue"
                      (click)="filterClicklistingpage(smartFilter[3]?.label,item.value[smartFilter[3]?.label],4)"
                      [ngClass]="{'active': json[smartFilter[3]?.label] === item.value[smartFilter[3]?.label] }">
                      {{item.value[smartFilter[3]?.label]}}
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="smartFilter?.length>4 && smartFilter[4]?.data && smartFilter[4]?.data?.length>0 ">
                <span class="filter-item" (click)="toggleDetails(smartFilter[4]?.label,'Cabin Type')"
                  [ngClass]="isDetailsVisible == smartFilter[4]?.label ? 'd-none' : ' '">
                  <img alt="" src="../../assets/advancesearch/FeaturePremium.png" />
                  <span *ngIf="smartFilter?.length > 0">{{smartFilter[4] | changelebels}}</span>

                </span>
                <div class="filter-item-details" [ngClass]="isDetailsVisible == smartFilter[4]?.label ? ' ' : 'd-none'">
                  <div class="filter-item-details-title">
                    <img alt=""
                      [src]="FifthFilter?'../../assets/advancesearch/list-item-icon5.png':'../../assets/advancesearch/FeaturePremium.png'" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[4] | changelebels}}</span>

                    <span class="ms-auto">5/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[4]?.data | keyvalue"
                      (click)="filterClicklistingpage(smartFilter[4]?.label,item.value[smartFilter[4]?.label],5)"
                      [ngClass]="{'active': json[smartFilter[4]?.label] === item.value[smartFilter[4]?.label] }">
                      {{item.value[smartFilter[4]?.label]}}
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="smartFilter?.length>5 && smartFilter[5]?.data && smartFilter[5]?.data?.length>0 ">
                <span class="filter-item" (click)="toggleDetails(smartFilter[5]?.label,'Cabin Type')"
                  [ngClass]="isDetailsVisible == smartFilter[5]?.label ? 'd-none' : ' '">
                  <img alt="" src="../../assets/advancesearch/SuspensionType.png" />
                  <span *ngIf="smartFilter?.length > 0">{{smartFilter[5] | changelebels}}</span>

                </span>
                <div class="filter-item-details" [ngClass]="isDetailsVisible == smartFilter[5]?.label ? ' ' : 'd-none'">
                  <div class="filter-item-details-title">
                    <img alt=""
                      [src]="SixthFilter?'../../assets/advancesearch/list-item-icon5.png':'../../assets/advancesearch/SuspensionType.png'" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[5] | changelebels}}</span>

                    <span class="ms-auto">6/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[5]?.data | keyvalue"
                      (click)="filterClicklistingpage(smartFilter[5]?.label,item.value[smartFilter[5]?.label],6)"
                      [ngClass]="{'active': json[smartFilter[5]?.label] === item.value[smartFilter[5]?.label] }">
                      {{item.value[smartFilter[5]?.label]}}
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
